import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchOrganizations } from "@/src/store/features/organizationsSlice";
import { fetchRegulations } from "@/src/store/features/regulationsSlice";
import { fetchArticles } from "@/src/store/features/articlesSlice";
import { fetchEvents } from "@/src/store/features/eventsSlice";
const initialState = {
  phase: "idle",
  started: false,
  lastCompleted: null,
  error: null
};
const toMessage = (error, fallback) => {
  if (typeof error === "string" && error.trim()) return error;
  if (error instanceof Error) return error.message;
  return fallback;
};
const bootstrapSlice = createSlice({
  name: "bootstrap",
  initialState,
  reducers: {
    setPhase(state, action) {
      state.phase = action.payload;
      state.started = action.payload !== "idle";
      if (action.payload !== "error") {
        state.error = null;
      }
    },
    setLastCompleted(state, action) {
      state.lastCompleted = action.payload;
    },
    setBootstrapError(state, action) {
      state.phase = action.payload ? "error" : state.phase;
      state.error = action.payload;
      state.started = true;
    },
    resetBootstrap() {
      return initialState;
    }
  }
});
export const {
  setPhase,
  setLastCompleted,
  setBootstrapError,
  resetBootstrap
} = bootstrapSlice.actions;
export const bootstrapApp = createAsyncThunk("bootstrap/run", async (_, {
  dispatch,
  rejectWithValue
}) => {
  try {
    dispatch(setPhase("fetching-organizations"));
    await dispatch(fetchOrganizations()).unwrap();
    dispatch(setLastCompleted("organizations"));
    dispatch(setPhase("fetching-regulations"));
    await dispatch(fetchRegulations()).unwrap();
    dispatch(setLastCompleted("regulations"));
    dispatch(setPhase("fetching-articles"));
    await dispatch(fetchArticles()).unwrap();
    dispatch(setLastCompleted("articles"));
    dispatch(setPhase("fetching-events"));
    await dispatch(fetchEvents()).unwrap();
    dispatch(setLastCompleted("events"));
    dispatch(setPhase("ready"));
  } catch (error) {
    const message = toMessage(error, "Bootstrap failed");
    dispatch(setBootstrapError(message));
    return rejectWithValue(message);
  }
}, {
  condition: (_, {
    getState
  }) => {
    const {
      phase
    } = getState().bootstrap;
    return phase === "idle" || phase === "error";
  }
});
export const selectBootstrapPhase = state => state.bootstrap.phase;
export const selectBootstrapError = state => state.bootstrap.error;
export const selectBootstrapStarted = state => state.bootstrap.started;
export const selectBootstrapLastCompleted = state => state.bootstrap.lastCompleted;
export default bootstrapSlice.reducer;